import {localTimeFormat} from 'common/formats';
import dayjs from 'dayjs';
import {isString} from 'lodash';
import {date} from 'yup';
import {CONTEXT_SEND_PARAMETER} from '../constants';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

export const localTime = () =>
   date().when(CONTEXT_SEND_PARAMETER, {
      is: true,
      then: date().transform(function (val, origin) {
         // console.debug(val, origin);
         if (isString(val) && val.length === localTimeFormat.length) {
            return val;
         }

         const day = dayjs(origin);
         if (!day.isValid()) return null;

         return day.format(localTimeFormat);
      }),
      otherwise: date().transform(function (val, origin) {
         if (this.isType(val) && dayjs(val).isValid()) {
            return val;
         }
         const time = dayjs(origin, localTimeFormat);
         // console.debug(time, localTimeFormat);
         return time.toDate();
      }),
   });
